/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useActiveFlow } from "../useActiveFlow";
import { writePaymentCallbackHash, getPaymentStatusRoute } from "../../utils/paymentCallback";

/** Routes to the payment status page after an in-app (popup) payment return. */
const useNavigateToPaymentStatus = () => {
  const navigate = useNavigate();
  const activeFlow = useActiveFlow();

  return useCallback(
    (invoiceId, system) => {
      writePaymentCallbackHash(invoiceId, system);
      navigate(getPaymentStatusRoute(activeFlow));
    },
    [navigate, activeFlow]
  );
};

export default useNavigateToPaymentStatus;
